/* The Broward Design Center — "Recently viewed" for high-consideration buyers.
   No app. On each PDP the current handle is recorded to localStorage (most
   recent first). The section renders the previously-viewed pieces (excluding
   the current one) by fetching each card via /products/{handle}?view=card.
   The section stays hidden until at least one card loads, so first-time
   visitors never see an empty band. */
(function () {
  var KEY = 'bdc-recently-viewed';
  var MAX = 12; // how many to remember
  var SHOW = 4; // how many to display

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }
  function track(handle) {
    if (!handle) return;
    var list = read().filter(function (h) { return h !== handle; });
    list.unshift(handle);
    if (list.length > MAX) list = list.slice(0, MAX);
    write(list);
  }

  function render(section) {
    var grid = section.querySelector('[data-recently-viewed-grid]');
    var current = section.getAttribute('data-current-handle');
    if (!grid) return;
    var handles = read().filter(function (h) { return h !== current; }).slice(0, SHOW);
    if (!handles.length) return; // stays hidden

    Promise.all(handles.map(function (handle) {
      return fetch('/products/' + encodeURIComponent(handle) + '?view=card')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (!html) return null;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          return doc.querySelector('[data-product-card]');
        })
        .catch(function () { return null; });
    })).then(function (cards) {
      var real = cards.filter(Boolean);
      if (!real.length) return; // nothing loaded — leave hidden
      real.forEach(function (card) { grid.appendChild(card); });
      section.hidden = false;
      // let the wishlist script bind hearts on the injected cards
      if (window.BDCWishlist && window.BDCWishlist.refresh) window.BDCWishlist.refresh();
    });
  }

  function init() {
    var section = document.querySelector('[data-recently-viewed]');
    if (!section) return;
    var current = section.getAttribute('data-current-handle');
    render(section); // render previously-viewed first (excludes current)
    track(current);  // then record this view
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
